module.exports = __webpack_public_path__ + "static/media/view-customize-investor-report.32fa2f67.svg";